export default __webpack_public_path__ + "static/media/Poppins-Medium.c5eb7098.ttf";